function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-bg border-t border-brand-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-8 text-center">
          <div>
            <h3 className="font-heading text-xl text-brand-primary mb-2">
              Primatif
            </h3>
            <p className="text-brand-text text-sm max-w-md mx-auto">
              Professional consulting services to help your business thrive in
              today&apos;s competitive landscape.
            </p>
          </div>

          <div className="mt-8 pt-8 border-t border-brand-surface">
            <p className="text-sm text-brand-text/70">
              © {currentYear} Primatif. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
